// extracted by mini-css-extract-plugin
export default {"root":"ConfirmationPage_root__6bx86","homeButton":"ConfirmationPage_homeButton__J1-uA"};